import {
    AppBar, Backdrop, Box, Button, ButtonGroup, Dialog, DialogActions, DialogContent,
    DialogContentText, Grid, IconButton, Toolbar, Typography
} from '@material-ui/core';
import moment from 'moment';
import CloseIcon from '@material-ui/icons/Close';
import Snackbar from '@material-ui/core/Snackbar';
import React, { useEffect, useState } from 'react';
import PuffLoader from "react-spinners/PuffLoader";
import { DropzoneArea } from 'material-ui-dropzone';
import { useTheme } from '@material-ui/core/styles';
import CancelIcon from '@mui/icons-material/Cancel';
import "@react-pdf-viewer/core/lib/styles/index.css";
import { Scrollbars } from 'react-custom-scrollbars';
import useStyles from '../../GlobalStyles/DocumentCss';
import { Viewer, Worker } from '@react-pdf-viewer/core';
import { IFileGet } from "../../../models/Roll/IFileGet";
import { clientBackup } from '../../../constants/Constant';
import LightTooltip from '../../GlobalStyles/LightTooltip';
import VisibilityIcon from '@material-ui/icons/Visibility';
import UploadFileIcon from '@mui/icons-material/UploadFile';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import header from '../../../images/header/header-logo.svg';
import MuiAlert, { AlertProps } from '@material-ui/lab/Alert';
import "@react-pdf-viewer/default-layout/lib/styles/index.css";
import PaidLetter from "../../Inquiry/LetterDetails/PaidLetter";
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import { IUserInvited } from '../../../models/common/IUserInvited';
import { Transition } from '../../GlobalStyles/DialogBoxTransition';
import { defaultLayoutPlugin } from "@react-pdf-viewer/default-layout";
import { useDelete, useFetch, usePost } from '../../../utils/apiHelper';
import { GlobalStateAction, useGlobalState } from '../../../store/GlobalStore';
import CreditReportUpdated from "../../Inquiry/LetterDetails/CreditReportUpdated";
import { DialogTitleDelete, DialogTitleHeader } from '../../GlobalStyles/DialogStyle';
import { ILetterDetails } from '../../../models/Inquiry/LetterDetails/ILetterDetails';
import CreditReportNotAffected from "../../Inquiry/LetterDetails/CreditReportingNotAffected";
import CreditReportNotMentioned from "../../Inquiry/LetterDetails/CreditReportingNotMentioned";
import { IAgentTemplatePermission } from '../../../models/AgentInquiry/IAgentTemplatePermission';
import { IClosedLetterDetails } from '../../../models/Inquiry/LetterDetails/IClosedLetterDetails';

const DocumentUpload: React.FC<{ clientId: string, letterDetails: IClosedLetterDetails[], agencyId: string, accountId: string, onHideNotification: (dbtNo: string) => void, BlockAwaitAccess: boolean, GetDebtorLetterDetails: ILetterDetails[], dbt_status: string, templateAccess: IAgentTemplatePermission }> = (props) => {
    const theme = useTheme();
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const { state, dispatch } = useGlobalState();
    const base = ("data:application/pdf;base64,");
    const [openDocs, setOpenDocs] = useState(false);
    const [serviceURL, setServiceURL] = useState('');
    const [alertOpen, setAlertOpen] = useState(false);
    const [fileExists, setFileExists] = useState(false);
    const [undoUpload, setUndoUpload] = useState(false);
    const [isDialogOpen, setDialogOpen] = useState(false);
    const [ProgressBar, setshowProgressBar] = useState(false);
    const defaultLayoutPluginInstance = defaultLayoutPlugin();
    const [CheckInvited, setCheckInvited] = useState<number>(0);
    const [FileDisplay, setFileDisplay] = useState<IFileGet[]>([]);
    const fullScreen = useMediaQuery(theme.breakpoints.down('sm'));
    const [isValidDocument, setIsValidDocument] = useState<boolean>(false);

    const handleAlertClose = () => {
        setAlertOpen(false);
        setIsValidDocument(false);
    };

    function handleCloseDialog() {
        setDialogOpen(false);
    }
    const handleClickOpen = () => {
        setOpen(true);
    };

    const handleCloseDocs = () => {
        setOpenDocs(false);
    };

    const handleClose = () => {
        setOpen(false);
    };

    function Alert(props: AlertProps) {
        return <MuiAlert elevation={6} variant="filled" {...props} />;
    }

    const closeSnackbar = (event?: React.SyntheticEvent, reason?: string) => {
        if (reason === 'clickaway') {
            return;
        }
        setUndoUpload(false);
        setFileExists(false);
    };

    useEffect(() => {
        (async () => {
            if (state?.AgentUserAccessContext?.agentUserId !== undefined) {
                await useFetch<IUserInvited[]>(`User/CheckUserInvited?userId=${state?.AgentUserAccessContext?.agentUserId}`).then((r) => {
                    setCheckInvited(r.data[0]?.user_id);
                });
            }
        })()
    }, []);

    const onSubmit = (selectedFile: File) => {
        if (selectedFile) {
            setshowProgressBar(true);
            if ((selectedFile?.type === 'image/jpeg' || selectedFile?.type === 'application/pdf') && selectedFile?.size > 0) {
                (async () => {
                    const formData = new FormData();
                    let dateTime = new Date(Date.now());
                    const currentDate = moment(dateTime).format('MMDDYY');
                    const fileExtension = selectedFile?.name?.split('.')?.pop();
                    const fileName = `${props?.agencyId}-${currentDate}${props?.clientId}-BU.${fileExtension}`;
                    formData.append("FormFile", selectedFile);
                    formData.append("FileName", fileName);
                    formData.append("FileSize", selectedFile?.size.toString());
                    formData.append("UserId", state?.AgentUserAccessContext?.agentUserId?.toString());
                    formData.append("CategoryId", "3");

                    await usePost<any>("WebViewFiles/InsertBackUpFiles", formData).finally(() => {
                        setshowProgressBar(false);
                    });
                    props.onHideNotification(props.agencyId);
                    getFileDisplayAsync();
                    UploadBackUpFile(selectedFile);
                })().finally(() => {
                    setshowProgressBar(false);
                    getFileDisplayAsync();
                })
            } else if (selectedFile?.size <= 0) {
                setAlertOpen(true);
                setIsValidDocument(true);
                setshowProgressBar(false);
            } else {
                setIsValidDocument(false);
                setshowProgressBar(false);
                setAlertOpen(true);
            }
        }
    }

    const UploadBackUpFile = (selectedFile: File) => {
        if (selectedFile) {
            if (selectedFile?.type === 'image/jpeg' || selectedFile?.type === 'application/pdf') {
                (async () => {
                    const formData = new FormData();
                    let dateTime = new Date(Date.now());
                    const currentDate = moment(dateTime).format('MMDDYY');
                    const fileExtension = selectedFile?.name?.split('.')?.pop();
                    const fileName = `${props?.agencyId}-${currentDate}${props?.clientId}-BU.${fileExtension}`;
                    formData.append("FormFile", selectedFile);
                    formData.append("ClientId", props?.clientId);
                    formData.append("file_name", fileName);
                    formData.append("userid", state?.AgentUserAccessContext?.agentUserId?.toString());
                    formData.append("rid", props?.agencyId)
                    formData.append("upload_date", dateTime.toString());
                    formData.append("file_size", selectedFile?.size.toString());
                    formData.append("ContainerName", clientBackup);

                    await usePost<any>("File/FileInsert", formData);
                })().finally(() => {
                    getFileDisplayAsync();
                })
            }
        }
    }

    useEffect(() => {
        getFileDisplayAsync();
    }, [])

    async function getFileDisplayAsync() {
        dispatch({ type: GlobalStateAction.Busy });
        try {
            await useFetch<IFileGet[]>("File/FileDetails?DBTNumber=" + props.agencyId).then((GetFileDetails) => {
                setFileDisplay(GetFileDetails.data);
            });
        }
        catch (ex) {
            dispatch({ type: GlobalStateAction.Error, error: ex });
            dispatch({ type: GlobalStateAction.Idle });
        }
        finally {
            dispatch({ type: GlobalStateAction.Idle });
        }
    }

    async function FileDeleteAsync(file_Id: string) {
        setDialogOpen(false);
        setshowProgressBar(true);
        await useDelete<any>("File/FileDelete?fileId=" + file_Id).finally(() => {
            getFileDisplayAsync();
            setUndoUpload(false);
            setshowProgressBar(false);
            setUndoUpload(true);
        });
    }

    function getPDFFileAsync(blobUri: string) {
        (async () => {
            setshowProgressBar(true);
            let request = {
                "blobUri": blobUri
            }
            await usePost<any>("File/GetBlobFileContent", request).then((r) => {
                let url = URL.createObjectURL(base64toBlob(base + r?.data));
                setServiceURL(url);
                setOpenDocs((r?.status === 404 || r?.status === 400) ? false : true);
            }).catch(() => {
                setFileExists(true);
            }).finally(() => {
                setshowProgressBar(false);
            });
        })();

        const base64toBlob = (data: string) => {
            // Cut the prefix `data:application/pdf;base64` from the raw base 64
            const base64WithoutPrefix = data.substring('data:application/pdf;base64,'.length);
            const bytes = window.atob(base64WithoutPrefix);
            let length = bytes.length;
            let out = new Uint8Array(length);
            while (length--) {
                out[length] = bytes.charCodeAt(length);
            }
            return new Blob([out], { type: 'application/pdf' });
        };
    }


    async function DownloadFileAsync(blobUri: string, fileName: string) {
        (async () => {
            setshowProgressBar(true);
            let request = {
                "blobUri": blobUri
            }
            await usePost<any>("File/GetBlobFileContent", request).then((r) => {
                const arrayBuffer = base64ToArrayBuffer(r.data);
                createAndDownloadBlobFile(arrayBuffer, fileName);
            }).catch(() => {
                setFileExists(true);
            }).finally(() => {
                setshowProgressBar(false);
            });
        })();
    }

    function base64ToArrayBuffer(base64: string) {
        const binaryString = window.atob(base64);
        const bytes = new Uint8Array(binaryString.length);
        return bytes.map((byte, i) => binaryString.charCodeAt(i));
    }

    function createAndDownloadBlobFile(body, filename) {
        const blob = new Blob([body]);
        const fileName = `${filename}`;
        const link = document.createElement('a');
        if (link.download !== undefined) {
            const url = URL.createObjectURL(blob);
            link.setAttribute('href', url);
            link.setAttribute('download', fileName);
            link.style.visibility = 'hidden';
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        }
    }

    return (
        <React.Fragment>
            <Dialog TransitionComponent={Transition}
                fullScreen={fullScreen} open={alertOpen} onClose={handleAlertClose} maxWidth={'sm'}
                aria-labelledby="responsive-dialog-title" PaperProps={{ style: { borderRadius: 10 } }} >
                <DialogTitleDelete id="responsive-dialog-title" onClose={handleAlertClose}>
                    <Typography variant="h5" gutterBottom className={classes.titleheader}>
                        MESSAGE
                    </Typography>
                </DialogTitleDelete>
                <DialogContent>
                    <DialogContentText>
                        {isValidDocument ?
                            <Typography variant="h5" className={classes.MessageStyle} gutterBottom>
                                The document upload failed due to an empty or corrupt file.
                            </Typography>
                            :
                            <Typography variant="h5" className={classes.MessageStyle} gutterBottom>
                                Invalid File Type. Please select a PDF or JPG file.
                            </Typography>
                        }
                    </DialogContentText>
                </DialogContent>
                <DialogActions >
                    <Button size="small" id="DU_ok_btn" variant="contained" onClick={(e) => { setAlertOpen(false); }} className={classes.yesButton}>
                        Yes
                    </Button>
                </DialogActions>
            </Dialog>

            <Button id="I_DocumentUpload" variant="contained" color="primary" className={`${classes.documentButton} ${classes.buttoncloseSpacing}`}
                startIcon={<UploadFileIcon style={{ fontSize: 22 }} />}
                onClick={(_) => { handleClickOpen(); }} >
                Document
            </Button>

            {openDocs ?
                <Dialog fullScreen className={classes.dialog} open={openDocs} onClose={handleCloseDocs} TransitionComponent={Transition}>
                    <AppBar position="fixed" className={classes.appBar}>
                        <Toolbar className={classes.toolbarStyle}>
                            <Typography variant="h6" >
                                <img alt="ARM_Solutions" className={classes.menuButton} src={header} />
                            </Typography>
                            <Typography variant="h6" className={classes.title} >
                                <b>DOCUMENT VIEWER</b>
                            </Typography>
                            <IconButton edge="end" color="inherit" onClick={() => setOpenDocs(false)} aria-label="close" >
                                <CloseIcon style={{ color: '#000', fontSize: 25 }} />
                            </IconButton>
                        </Toolbar>
                    </AppBar>
                    <Worker workerUrl="https://unpkg.com/pdfjs-dist@2.16.105/build/pdf.worker.min.js">
                        <Viewer fileUrl={serviceURL} plugins={[defaultLayoutPluginInstance]} />
                    </Worker>
                </Dialog> : null}

            <Dialog open={open} TransitionComponent={Transition} keepMounted onClose={handleClose}
                classes={{ paper: classes.dialogeDocumentPaper }}
                PaperProps={{ style: { borderRadius: 15 } }}
                aria-labelledby="alert-dialog-slide-title" aria-describedby="alert-dialog-slide-description">
                <DialogTitleHeader id="responsive-dialog-title" onClose={handleClose}>
                    <Typography variant="h6" gutterBottom className={classes.titleheader}>
                        DOCUMENT UPLOAD
                    </Typography>
                </DialogTitleHeader>
                <Backdrop className={classes.backdrop} open={ProgressBar}>
                    <PuffLoader size={80} color={"white"} speedMultiplier={1} />
                </Backdrop>
                <DialogContent className={classes.dialogSpacingTop}>
                    <Grid container spacing={0}>
                        <Grid item xs={12}>
                            <DropzoneArea
                                filesLimit={1}
                                showPreviews={false}
                                showPreviewsInDropzone={false}
                                onChange={(files) => onSubmit(files[0])}
                                acceptedFiles={['image/jpeg', 'application/pdf']}
                            />
                        </Grid>
                        <Grid item xs={7} >
                            <Typography variant="h6" className={classes.typoTitle1} ><b>Documents</b></Typography>
                            <Box p={0} width="100%" flexShrink={0} bgcolor="white"  >
                                <Scrollbars autoHide={false}
                                    autoHeight
                                    className={classes.Documents}
                                    autoHeightMin={160}
                                    autoHeightMax={160}
                                    style={{ width: "100%" }}>
                                    {!FileDisplay.length ?
                                        < Typography variant="h6" gutterBottom className={classes.norecord}>
                                            No Documents to display..
                                        </Typography>
                                        : null}
                                    {FileDisplay.map((f) => {
                                        let enable = f.file_Name.split('.').pop() === 'pdf' ? true : f.file_Name.split('.').pop() === 'PDF' ? true : false
                                        return (
                                            <React.Fragment>
                                                <div className={classes.documentStyle}>
                                                    <Box p={0} display="flex" justifyContent="flex-start" width="95%" bgcolor="white" style={{ backgroundColor: 'white' }}>
                                                        <Box p={0} width='79%' flexShrink={0} bgcolor="white" >
                                                            <Typography variant="subtitle2" className={classes.typoStyle}>
                                                                {f.file_Name} - {moment(f.upload_Date).format(state.GlobalUtils?.settingValue)}
                                                            </Typography>
                                                        </Box>
                                                        <Box p={0} width='7%' flexShrink={0} bgcolor="white" >
                                                            <IconButton disabled={!enable} aria-label="delete" onClick={handleClickOpen} className={classes.Iconbutton}>
                                                                <LightTooltip title="Preview File">
                                                                    <VisibilityIcon onClick={() => { getPDFFileAsync(f.blobUri); }}
                                                                        className={!enable ? classes.NonVisible : classes.Visible} />
                                                                </LightTooltip>
                                                            </IconButton>
                                                        </Box>
                                                        <Box p={0} width='7%' flexShrink={0} bgcolor="white" >
                                                            <IconButton aria-label="delete" className={classes.Iconbutton}>
                                                                <LightTooltip title="Download File">
                                                                    <CloudDownloadIcon onClick={() => { DownloadFileAsync(f.blobUri, f.file_Name); }} className={classes.iconStyle} />
                                                                </LightTooltip>
                                                            </IconButton>
                                                        </Box>
                                                    </Box>
                                                </div>
                                                <Dialog TransitionComponent={Transition}
                                                    PaperProps={{ style: { borderRadius: 15 } }}
                                                    open={isDialogOpen}
                                                    onClose={handleCloseDialog}
                                                    aria-labelledby="alert-dialog-title"
                                                    aria-describedby="alert-dialog-description"
                                                    maxWidth={'xs'}
                                                >
                                                    <DialogTitleHeader id="responsive-dialog-title" onClose={handleCloseDialog}>
                                                        <Typography variant="h6" gutterBottom className={classes.titleheader}>
                                                            File Delete
                                                        </Typography>
                                                    </DialogTitleHeader>
                                                    <DialogContent >
                                                        <Typography variant="h6" style={{ color: "black" }} gutterBottom>
                                                            Are you sure, you want to Delete this File?
                                                        </Typography>
                                                    </DialogContent>
                                                    <DialogActions>
                                                        <Button id="NRB_ok_btn" size="small" variant="contained" color="primary" className={classes.yesbutton} onClick={() => { FileDeleteAsync(f.file_Id); }}>
                                                            Yes
                                                        </Button>
                                                        <Button id="NRB_cancel_btn" size="small" onClick={handleCloseDialog} className={classes.nobutton} color="primary">
                                                            No
                                                        </Button>
                                                    </DialogActions>
                                                </Dialog>
                                            </React.Fragment>
                                        )
                                    })}
                                </Scrollbars>
                            </Box>
                        </Grid>
                        <Grid item xs={5} >
                            <Typography variant="h6" className={classes.LetterStyle}> <b>Request a letter</b> </Typography>
                            <ButtonGroup
                                fullWidth
                                id="I_D_Letters"
                                className={classes.head}
                                aria-label="full width outlined button group"
                                classes={{ groupedOutlined: classes.groupedOutlined }} >
                                <PaidLetter dbtNumber={props.agencyId} letterDetails={props.letterDetails} GetDebtorLetterDetails={props.GetDebtorLetterDetails} />
                                <CreditReportNotMentioned dbtNumber={props.agencyId} letterDetails={props.letterDetails} GetDebtorLetterDetails={props.GetDebtorLetterDetails} />
                                <CreditReportUpdated dbtNumber={props.agencyId} letterDetails={props.letterDetails} GetDebtorLetterDetails={props.GetDebtorLetterDetails} />
                                <CreditReportNotAffected dbtNumber={props.agencyId} letterDetails={props.letterDetails} GetDebtorLetterDetails={props.GetDebtorLetterDetails} />
                            </ButtonGroup>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button id="I_D_Close_btn" variant="outlined" size="small" onClick={handleClose} startIcon={<CancelIcon />} className={classes.cancel} >
                        Cancel
                    </Button>
                </DialogActions>
            </Dialog>

            <Snackbar open={fileExists} className="snackBarStyle" anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={closeSnackbar}>
                <Alert onClose={closeSnackbar} severity="error" className="alertStyle">
                    File does not exists!
                </Alert>
            </Snackbar>
            <Snackbar className="snackBarStyle" open={undoUpload} anchorOrigin={{
                vertical: 'top',
                horizontal: 'center',
            }} autoHideDuration={4000} onClose={closeSnackbar}>
                <Alert onClose={closeSnackbar} severity="error" className="alertStyle">
                    File Deleted Successfully!
                </Alert>
            </Snackbar>

        </React.Fragment >
    )
}

export default DocumentUpload